export type MatchFilterInput = {
  status: string;
  competition: string;
  homeTeam: string;
  awayTeam: string;
};

export function filterMatches<T extends MatchFilterInput>(
  matches: T[],
  options: { status?: string; competition?: string; favoriteTeam?: string },
): T[] {
  return matches.filter((match) =>
    (!options.status || options.status === "all" || match.status === options.status) &&
    (!options.competition || options.competition === "all" || match.competition === options.competition) &&
    (!options.favoriteTeam || options.favoriteTeam === "all" || match.homeTeam === options.favoriteTeam || match.awayTeam === options.favoriteTeam),
  );
}
